export default "This view offers an overview of the **Calls and Costs Report**. The data from the current day is \nalways excluded.\n";